import { put } from "redux-saga/effects";

import { davInstance } from "axios-config";
import * as actions from "store/actions";
import { encodeHandler } from "utils";

export function* inviteUsersStart(action) {
  try {
    const response = yield davInstance.post(
      "/subUser/inviteUsers",
      action.details
    );

    if (response.data.code === "OK") {
      yield put(actions.inviteUsersSuccess(response.data.message));
    } else if (response.data.code === 400) {
      yield put(actions.inviteUsersFailure(response.data.message.message));
    }
  } catch (error) {
    console.log(error);
  }
}

export function* fetchUsersListStart(action) {
  try {
    const response = yield davInstance.get(
      "/subUser/getsubuserslist",
      action.details
    );
    if (response.status === 200) {
      yield put(actions.fetchUsersListSuccess(response.data));
    }
  } catch (error) {
    console.log(error);
  }
}

export function* resendInvitationStart(action) {
  try {
    const response = yield davInstance.post(
      "/subUser/resendInvitation?email=" + encodeHandler(action.email)
    );

    if (response.status === 200) {
      yield put(actions.resendInvitationSuccess(action.email));
    }
    if (response.status === 500) {
      yield put(actions.resendInvitationFailed(action.email));
    }
  } catch (err) {
    console.log(err);
  }
}

export function* deleteSubUserStart(action) {
  try {
    action.isInvite = false;
    const response = yield davInstance.post(
      "/subUser/cancelsubuser?mid=" + action.mirrorID
    );

    if (response.status === 200) {
      if (response.data.code === 400 || response.data.code === 500) {
        yield put(actions.deleteSubUserFailed(action));
      } else {
        yield put(actions.deleteSubUserSuccess(action));
      }
    }
    if (response.status === 400 || response.status === 500) {
      yield put(actions.deleteSubUserFailed(action));
    }
  } catch (err) {
    console.log(err);
  }
}

export function* cancelUserInviteStart(action) {
  try {
    action.isInvite = true;
    const response = yield davInstance.post(
      "/subUser/cancelInvite?invid=" + action.inviteID
    );

    if (response.status === 200) {
      if (response.data.code === 400 || response.data.code === 500) {
        yield put(actions.deleteSubUserFailed(action));
      } else {
        yield put(actions.deleteSubUserSuccess(action));
      }
    }
    if (response.status === 400 || response.status === 500) {
      yield put(actions.deleteSubUserFailed(action));
    }
  } catch (err) {
    console.log(err);
  }
}
